<template>
  <div class="mxMobileContent">
    <div class="title">{{ $t("mxHarmonyTitle") }}</div>
    <div class="desc">{{ $t("mxLongContent") }}</div>
    <div class="qrcode">
      <img
        class="group-code"
        src="../assets/downloadImg/harmony-group.png"
        alt=""
      />
      <img class="qrcode_icon" src="../assets/downloadImg/logo2.png" alt="" />
    </div>
    <div class="scan-hint">{{ $t("mx.mobile_harmonyScan") }}</div>
    <div class="group-hint">{{ $t("mx.mobile_joinGroup") }}</div>
    <div class="group-num">
      <div>{{ groupNum }}</div>
      <img
        class="copy-btn"
        src="../assets/downloadImg/copy.png"
        @click="onCopy"
      />
    </div>
  </div>
</template>
<script>
import CopyGroupnumber from "./js/copy-groupnumber";
export default {
  mixins: [CopyGroupnumber]
};
</script>
<style lang="less" scoped>
.mxMobileContent {
  padding-top: 100px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  font-size: 14px;
  .title {
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #191919;
    line-height: 48px;
  }
  .desc {
    margin-top: 4px;
    font-size: 16px;
    color: #666666;
    line-height: 24px;
  }
  .qrcode {
    margin-top: 28px;
    position: relative;
    z-index: 49;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;
    background-color: #ffffff;
    .group-code {
      width: 156px;
      height: auto;
      object-fit: scale-down;
    }
    .qrcode_icon {
      position: absolute;
      z-index: 50;
      width: 46px;
      height: 46px;
    }
  }
  .scan-hint {
    line-height: 22px;
    text-align: center;
    color: #8d8d8d;
    margin-top: 8px;
  }
  .group-hint {
    line-height: 24px;
    text-align: center;
    color: #666666;
    margin-top: 24px;
  }
  .group-num {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 4px;
    color: #666666;
    line-height: 24px;
    .copy-btn {
      margin-left: 12px;
      width: 20px;
      height: 20px;
      cursor: pointer;
    }
  }
}
</style>
